import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap } from "rxjs/operators";

import { Guest } from "@hermes/api-model-account";
import { StorageManager, StorageService } from "@hermes/core-app-core";

import { BasketFacade } from "@hermes/hermes-web-states-basket-state";

import {
    clearUserData,
    clearUserDataSuccess,
    fetchGuest,
    fetchGuestSuccess,
    removeGuest,
    removeGuestSuccess,
    updateGuest,
} from "../actions/user.actions";
import { UserStateService } from "../services/user-state.service";

@Injectable()
export class UserEffects {
    private actions$ = inject(Actions);
    private basketFacade = inject(BasketFacade);
    private storageService = inject(StorageService);
    private userService = inject(UserStateService);
    private sessionStorageInstance?: StorageManager;

    constructor() {
        this.sessionStorageInstance =
            this.storageService.getSessionStorageInstance();
    }

    public fetchGuest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchGuest),
            switchMap(() => [
                fetchGuestSuccess({
                    guest: this.sessionStorageInstance?.getItem(
                        "guest",
                    ) as Guest,
                }),
            ]),
        ),
    );

    public removeGuest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(removeGuest),
            switchMap(() => {
                this.sessionStorageInstance?.deleteItem("guest");
                return [removeGuestSuccess()];
            }),
        ),
    );

    public updateGuest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateGuest),
            switchMap((payload) => {
                if (payload.guest) {
                    this.sessionStorageInstance?.setItem(
                        "guest",
                        payload.guest,
                    );
                }
                return [fetchGuest()];
            }),
        ),
    );

    public clearUserData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(clearUserData),
            switchMap(() => {
                this.userService.clearUser();
                this.basketFacade.clearData();
                return [clearUserDataSuccess()];
            }),
        ),
    );
}
